import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const StyledIndicator = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  padding: '4px 12px',
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  textTransform: 'uppercase',
  borderRadius: 4,
}));

const IsNewCommentIndicator = () => (
  <StyledIndicator>
    <FormattedMessage id="portfolio.challenge.coach_comments.coach_comment.new" />
  </StyledIndicator>
);

export default IsNewCommentIndicator;
